import { createSelector } from '@reduxjs/toolkit';
import { employeesNotDeleted } from './employees-not-deleted';

export const employeesNotTerminatedCount = createSelector(employeesNotDeleted, (employees): number => {
  return employees.filter((e) => e.status !== 'TERMINATED').length;
});
